import React from "react";
import "./LandingBanner.scss";

// Components
import Heading01 from "components/Headings/Heading01/Heading01";
import AnimatedLetters from "components/Headings/Common/Utils/Animation/AnimatedLetters";

function LandingBanner({ title = "Logo Design", banner }) {
  return (
    <div className="landingBanner">
      {/* Overlay */}
      <div className="landingBanner__overlay"></div>
      {/* Image */}
      <div className="landingBanner__image">
        <img src={banner} alt="" />
      </div>
      {/* Title */}
      <div className="landingBanner__title">
        <Heading01>
          <AnimatedLetters text={title} />
        </Heading01>
      </div>
    </div>
  );
}

export default LandingBanner;
